import { Component, OnInit } from '@angular/core'
import { FollowUpService } from '../followup.service'
import { QuotationFollowUpModel } from '../models/quotation_follow_up.model'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { QuotationService } from '../quotation.service'
import { QuotationModel } from '../models/quotation.model'
import { ClientModel } from '../../client/client.model'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { UserModel } from '../../users/user_model'
import { MasterCommonServices } from '../master.common.service'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-viewfollowups',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './viewFollowUps.component.html',
  styleUrl: './viewFollowUps.component.css',
})
export class ViewFollowUpsComponent implements OnInit {
  quotationList: QuotationModel[] = []
  followUpsList: QuotationFollowUpModel[] = []
  selectedDueFilter: string = 'all'
  isLoading: boolean = false

  constructor(
    private quotationService: QuotationService,
    private followUpsService: FollowUpService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    private masterCommonServices: MasterCommonServices,
  ) {
    if (this.masterCommonServices.usersList.length === 0) {
      this.masterCommonServices.getAllUsers()
    }
    if(this.masterCommonServices.clientsList.length === 0) {
      this.masterCommonServices.getAllClients()
    }
    this.getAllQuotations()
    this.getAllFollowUps()
  }
  filter = {
    quoteId: '',
    clientName: '',
    assignedTo: '',
    followUpDate: '',
    nextFollowUpDate: '',
  }

  filteredFollowUpsList: QuotationFollowUpModel[] = []

  ngOnInit(): void {}

  getAllQuotations() {
    this.quotationService.getAllQuotations().subscribe({
      next: (data: QuotationModel[]) => {
        this.quotationList = data

        this.isLoading = false
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  getAllFollowUps() {
    this.isLoading = true
    this.followUpsService.getAllFollowUps().subscribe({
      next: (data: QuotationFollowUpModel[]) => {
        this.followUpsList = this.getMostRecentFollowUps(data)
        // default descending order by nextFollowUpDate / followUpDate / modifiedOn
        this.followUpsList.sort((a, b) => {
          const ad = a.nextFollowUpDate
            ? new Date(a.nextFollowUpDate)
            : a.followUpDate
            ? new Date(a.followUpDate)
            : new Date(a.modifiedOn)
          const bd = b.nextFollowUpDate
            ? new Date(b.nextFollowUpDate)
            : b.followUpDate
            ? new Date(b.followUpDate)
            : new Date(b.modifiedOn)
          return bd.getTime() - ad.getTime()
        })
        this.filteredFollowUpsList = [...this.followUpsList]
        this.isLoading = false
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  applyFilters(): void {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    // Calculate next week as the week that starts the Monday after the upcoming Sunday
    const daysUntilSunday = (7 - today.getDay()) % 7
    const upcomingSunday = new Date(today)
    upcomingSunday.setDate(today.getDate() + daysUntilSunday)
    upcomingSunday.setHours(0, 0, 0, 0)
    const nextWeekStart = new Date(upcomingSunday)
    nextWeekStart.setDate(upcomingSunday.getDate() + 1)
    nextWeekStart.setHours(0, 0, 0, 0)
    const nextWeekEnd = new Date(nextWeekStart)
    nextWeekEnd.setDate(nextWeekStart.getDate() + 6)
    nextWeekEnd.setHours(0, 0, 0, 0)

    this.filteredFollowUpsList = this.followUpsList.filter((fup) => {
      const quoteId = fup.quotationId.toString().toLowerCase()
      const clientName = this.getClientName(fup.quotationId).toLowerCase()
      const assignedTo = this.getAssignedToName(fup.quotationId).toLowerCase()
      const followUpDate = fup.followUpDate
        ? new Date(fup.followUpDate).toLocaleDateString('en-GB')
        : ''
      const nextFollowUpDate = fup.nextFollowUpDate
        ? new Date(fup.nextFollowUpDate).toLocaleDateString('en-GB')
        : ''
      const textMatch =
        (!this.filter.quoteId ||
          quoteId.includes(this.filter.quoteId.toLowerCase())) &&
        (!this.filter.clientName ||
          clientName.includes(this.filter.clientName.toLowerCase())) &&
        (!this.filter.assignedTo ||
          assignedTo.includes(this.filter.assignedTo.toLowerCase())) &&
        (!this.filter.followUpDate ||
          followUpDate.includes(this.filter.followUpDate)) &&
        (!this.filter.nextFollowUpDate ||
          nextFollowUpDate.includes(this.filter.nextFollowUpDate))

      // Due filter logic (based on nextFollowUpDate)
      let duePass = true
      if (this.selectedDueFilter && this.selectedDueFilter !== 'all') {
        if (!fup.nextFollowUpDate) {
          duePass = false
        } else {
          const nd = new Date(fup.nextFollowUpDate)
          nd.setHours(0, 0, 0, 0)
          if (this.selectedDueFilter === 'today') {
            duePass = nd.getTime() === today.getTime()
          } else if (this.selectedDueFilter === 'tomorrow') {
            duePass = nd.getTime() === tomorrow.getTime()
          } else if (this.selectedDueFilter === 'nextWeek') {
  duePass =
    nd.getTime() >= nextWeekStart.getTime() &&
    nd.getTime() <= nextWeekEnd.getTime()
}
        }
      }

      return textMatch && duePass
    })

    // ensure descending order after filtering
    this.filteredFollowUpsList.sort((a, b) => {
      const ad = a.nextFollowUpDate
        ? new Date(a.nextFollowUpDate)
        : a.followUpDate
        ? new Date(a.followUpDate)
        : new Date(a.modifiedOn)
      const bd = b.nextFollowUpDate
        ? new Date(b.nextFollowUpDate)
        : b.followUpDate
        ? new Date(b.followUpDate)
        : new Date(b.modifiedOn)
      return bd.getTime() - ad.getTime()
    })
  }
  
  resetFilters(): void {
    this.filter = {
      quoteId: '',
      clientName: '',
      assignedTo: '',
      followUpDate: '',
      nextFollowUpDate: '',
    }
    this.filteredFollowUpsList = [...this.followUpsList]
  }

  getMostRecentFollowUps(
    followUps: QuotationFollowUpModel[],
  ): QuotationFollowUpModel[] {
    const mostRecentFollowUps: { [key: number]: QuotationFollowUpModel } = {}

    followUps.forEach((followUp) => {
      const { quotationId, modifiedOn } = followUp

      if (
        !mostRecentFollowUps[quotationId] ||
        new Date(modifiedOn) >
          new Date(mostRecentFollowUps[quotationId].modifiedOn)
      ) {
        mostRecentFollowUps[quotationId] = followUp
      }
    })

    return Object.values(mostRecentFollowUps)
  }

  viewFollowUp(quotationIdFromNavigation: number): void {
    this.router.navigate(['/viewFollowUp', quotationIdFromNavigation])
  }

  deleteFollowUp(quotationfollowup: QuotationFollowUpModel): void {
    

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: 'Are you sure you want to delete this quotationfollowup?',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.followUpsService
          .deleteQuotationFollowUp(quotationfollowup)
          .subscribe({
            next: () => {
              this.followUpsList = this.followUpsList.filter(
                (p) => p.id !== quotationfollowup.id,
              )
              this.toastr.success(
                'QuotationFollowUp Deleted Successfully!',
                'Success',
              )
            },
            error: (error: any) => {
              this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
            },
          })
      }
    })
  }

  getClientName(quotationId: number): string {
    const quotation: QuotationModel | undefined = this.quotationList.find(
      (quot) => quot.quotationFields.id === quotationId,
    )
    if (quotation != undefined) {
      const client:
        | ClientModel
        | undefined = this.masterCommonServices.clientsList.find(
        (client) => client.id === quotation.quotationFields.quotationCompanyId,
      )
      if (client != undefined) {
        return client.companyName
      }
    }
    return ''
  }

  getAssignedToName(quotationId: number): string {
    const quotation: QuotationModel | undefined = this.quotationList.find(
      (quot) => quot.quotationFields.id === quotationId,
    )
    

    if (quotation != undefined) {
      const user = this.masterCommonServices.usersList.find(
        (user: UserModel) =>
          user.id === quotation?.quotationFields.quotationAssignedToId,
      )

      if (user != undefined) {
        return user.username
      }
    }
    return ''
  }
}
